import React, { useEffect, useState } from "react";
import { Card, Col, InputNumber, Row } from "antd";
import { DEFAULT_VISITOR_IDLE_STATE_TIME } from "../../../../utils/constants";

const VisitorIdleTime = ({ widget, handleWidgetChange }) => {
  const [time, setTime] = useState(DEFAULT_VISITOR_IDLE_STATE_TIME);

  useEffect(() => {
    if (widget.visitor_idle_state_time) setTime(widget.visitor_idle_state_time);
    else setTime(DEFAULT_VISITOR_IDLE_STATE_TIME);
  }, [widget.id, widget.visitor_idle_state_time]);

  const handleSave = () => {
    handleWidgetChange({ visitor_idle_state_time: time, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <Row className="center_items setting_label">
        <Col span={12}>
          <h4 className="p-color">Visitor Idle Time</h4>
        </Col>
        <Col span={12} className="action">
          <div style={{ textAlign: "end" }}>
            <InputNumber
              min={1}
              value={time}
              onChange={(value) => {
                setTime(value);
              }}
            />
          </div>

          <div onClick={handleSave} className="action_btn ml-2">
            <i className="fa-regular fa-floppy-disk"></i>
            <span>Save</span>
          </div>
        </Col>
      </Row>
      <p className="font13">
        The time taken (in minutes) to change visitors` status from active to
        idle from their last activity on a page.
      </p>
    </Card>
  );
};

export default React.memo(VisitorIdleTime);
